import b from 'b_';
import cx from 'classnames';
import React, { ReactNode } from 'react';

import './lesson-passport__tip.scss';

export enum LESSON_PASSPORT_TIP_THEME {
    GREEN = 'green',
    YELLOW = 'yellow',
    BLUE = 'blue',
}

interface Props {
    children: ReactNode | ReactNode[];
    mix?: string;
    theme?: LESSON_PASSPORT_TIP_THEME;
}

export const LessonPassportTip = React.memo(({ children, mix, theme = LESSON_PASSPORT_TIP_THEME.GREEN }: Props) => {
    return <div className={cx(b('lesson-passport', 'tip', { theme }), mix)}>{children}</div>;
});
